import {createDrawingCore} from './drawingCore';

export const handwritingLimits={maxPoints:300000,maxStrokes:30000,maxStrokePoints:10000,maxHeight:300000};

// Self-contained factory: used in React and inside the handwriting iframe.
export function createHandwritingModel(ink) {
    function normalize(value) {
        const paper=['ruled','grid','plain'].includes(value?.paper)?value.paper:'ruled';
        return {version:1,paper,drawings:ink.pack(value?.drawings)};
    }
    function svg(value) {
        const note=normalize(value),drawing=ink.normalize(note.drawings),bounds=ink.bounds(drawing);
        const width=Math.max(960,bounds.width),height=Math.max(1280,bounds.height);
        const pattern=note.paper==='ruled'?'<path d="M0 31.5H32" fill="none" stroke="#e3d9ee"/>':note.paper==='grid'?'<path d="M0 0H32V32" fill="none" stroke="#e3d9ee"/>':'';
        return '<svg xmlns="http://www.w3.org/2000/svg" width="'+width+'" height="'+height+'" viewBox="0 0 '+width+' '+height+'" role="img" aria-label="Hand notes"><rect width="100%" height="100%" fill="#fffefb"/><defs><pattern id="paper" width="32" height="32" patternUnits="userSpaceOnUse">'+pattern+'</pattern></defs><rect width="100%" height="100%" fill="url(#paper)"/>'+ink.paths(drawing)+'</svg>';
    }
    return {normalize,svg};
}
const model=createHandwritingModel(createDrawingCore(handwritingLimits));
export const normalizeHandNotes=model.normalize;
export const handNotesSVG=model.svg;
